export class ElearningCourse {
    categoryID: number;
    category: string;
}


// WEBPACK FOOTER //
// ./src/app/models/elearningCourse.ts